import { axiosInstance } from "@/lib/axios";

/** `GET /blockchain-status` — public, no sign-in; the `lang` header comes from the page like every call. */
export async function fetchBlockchainStatus(): Promise<unknown> {
  const res = await axiosInstance.get("/blockchain-status", { suppressToast: true });
  return res.data;
}
